import 'mdn-polyfills/NodeList.prototype.forEach';

export default class Video {
  constructor(element) {
    this.element = element;
    this.embedContainer = this.element.querySelector('.js-video-embed');
    this.vignette = this.element.querySelector('.js-video-vignette');
    this.checkbox = this.element.querySelector('.js-video-checkbox');
    this.button = this.element.querySelector('.js-video-button');
    this.consents = this.element.querySelectorAll('.js-video-consent');

    this.removeVignette = this.removeVignette.bind(this);
    this.insertFrame = this.insertFrame.bind(this);
    this.handleConsentChange = this.handleConsentChange.bind(this);
    this.handleConsentClick = this.handleConsentClick.bind(this);
  }

  removeVignette() {
    if (this.vignette) {
      this.vignette.remove();
      this.insertFrame(new Event('click'));
    }
  }

  insertFrame(event) {
    event.preventDefault();
    const frameContent = this.vignette ? this.vignette.getAttribute('data-frame') : null;

    if (this.embedContainer && frameContent) {
      this.embedContainer.innerHTML = frameContent;
      const iframe = this.embedContainer.querySelector('iframe');

      if (iframe) {
        let allowAttr = iframe.getAttribute('allow') || '';
        if (!allowAttr.includes('autoplay')) {
          allowAttr += ' autoplay';
        }
        iframe.setAttribute('allow', allowAttr);

        let src = iframe.getAttribute('src');
        if (src) {
          src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
          iframe.setAttribute('src', src);
        }
      }
    }
  }

  handleConsentChange() {
    if (this.checkbox) {
      this.button.disabled = !this.checkbox.checked;
    }
  }

  handleConsentClick() {
    if (this.checkbox && this.checkbox.checked) {
      this.removeVignette();
      this.consents.forEach(consent => consent.remove());
    }
  }

  mount() {
    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.handleConsentChange);
    }

    if (this.button && this.checkbox) {
      this.button.addEventListener('click', this.handleConsentClick);
    }

    if (this.vignette && !this.checkbox.checked) {
      this.vignette.addEventListener('click', this.insertFrame);
    }
  }
}
